/* eslint-disable @typescript-eslint/no-explicit-any */
import { Col } from '@design-system/components/grid/grid';
import { TextField } from '@client/new/components/basic';
import { useFormContext } from 'react-hook-form';
import { wrapper, fieldWrapper, fieldTitle, fieldDesc } from './forms.css';
import { SectionRenderer, SectionsSpecMap } from '../../model/domain';

export const IntroductionSection: SectionRenderer<'Introduction'> = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext<SectionsSpecMap['Introduction']['domain']>();

  return (
    <Col data-testid="introduction-section" className={wrapper} gap="m">
      {/* Headline */}
      <div className={fieldWrapper}>
        <h3 className={fieldTitle}>
          Headline<span className="text-red-500">*</span>
        </h3>
        <div className={fieldDesc}>
          The headline is used to communicate the creator&apos;s value
          proposition in the hero section of the sales page.
        </div>
        <TextField
          {...register('headlineText')}
          placeholder="Headline text"
          inputProps={{ maxLength: 60 }}
          errorMsg={errors.headlineText?.message}
        />
      </div>

      {/* Subtitle/Highlighted text */}
      <div className={fieldWrapper}>
        <h3 className={fieldTitle}>Highlighted text</h3>
        <div className={fieldDesc}>Some slogan</div>
        <TextField
          {...register('subtitle')}
          placeholder="Reach some goal"
          inputProps={{ maxLength: 60 }}
          errorMsg={errors.subtitle?.message}
        />
      </div>

      {/* Intro Text */}
      <div className={fieldWrapper}>
        <h3 className={fieldTitle}>
          Introduction text<span className="text-red-500">*</span>
        </h3>
        <div className={fieldDesc}>
          Describe the value proposition and benefits
        </div>
        <TextField
          {...register('introText')}
          placeholder="Introduction text"
          multiline
          rows={4}
          errorMsg={errors.introText?.message}
        />
      </div>

      {/* Cover Image URL */}
      <div className={fieldWrapper}>
        <h3 className={fieldTitle}>Cover image URL</h3>
        <div className={fieldDesc}>
          Square image/gif, max 5MB. Used as preview for the intro video.
        </div>
        <TextField
          {...register('coverImageUrl')}
          placeholder="https://example.com/image.jpg"
          errorMsg={errors.coverImageUrl?.message}
        />
      </div>

      {/* Intro Video URL */}
      <div className={fieldWrapper}>
        <h3 className={fieldTitle}>Intro video URL</h3>
        <div className={fieldDesc}>
          Max 90 seconds, max 100MB. Optional compelling introduction video.
        </div>
        <TextField
          {...register('introVideoUrl')}
          placeholder="https://example.com/video.mp4"
          errorMsg={errors.introVideoUrl?.message}
        />
      </div>

      {/* Primary Color */}
      <div className={fieldWrapper}>
        <h3 className={fieldTitle}>
          Primary color<span className="text-red-500">*</span>
        </h3>
        <div className={fieldDesc}>Primary color for the section theme</div>
        <TextField
          {...register('primaryColor')}
          placeholder="#000000"
          errorMsg={errors.primaryColor?.message}
        />
      </div>

      {/* CTA */}
      <div className={fieldWrapper}>
        <h3 className={fieldTitle}>
          CTA Text<span className="text-red-500">*</span>
        </h3>
        <TextField
          {...register('cta.text')}
          placeholder="Get Started"
          errorMsg={errors.cta?.text?.message}
        />
      </div>

      <div className={fieldWrapper}>
        <h3 className={fieldTitle}>CTA URL</h3>
        <TextField
          {...register('cta.link')}
          placeholder="https://example.com/action"
          errorMsg={errors.cta?.link?.message}
        />
      </div>
    </Col>
  );
};
